import React, { ReactElement, useState } from 'react';
import { CardPadding } from '../../shared/CardStyles';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../store/store';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import Icon from '@ramsey-design-system/icon';
import {
  LinkExternalIcon,
  RefreshIcon,
  DownloadOutlinedIcon,
  LinkIcon,
} from '@ramsey-design-system/icons';
import Button from '@ramsey-design-system/button';
import Input from '@ramsey-design-system/input';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';
import { resetState } from '../../../store/step';
import { getApiHostname } from '../../../utils/api/getApiHostname';

export function GetMyResultsStep(): ReactElement {
  const dispatch = useDispatch();
  const { guid } = useSelector((state: RootState) => state.steps);
  const [copyButtonMessage, setCopyButtonMessage] = useState('Copy');

  const formRef = useFormInteractionTracking('get_my_results');

  function copyToClipboard(): void {
    const element = document.getElementById('copyCoverageCheckupLink');
    const textToCopy = element?.getAttribute('value') || '';
    if (textToCopy) {
      navigator.clipboard.writeText(textToCopy);
      setCopyButtonMessage('Copied');
    }
  }

  return (
    <CardPadding>
      <div className="text-center pt-6 cc-GetMyResultsStep">
        <CardHeader
          header="All done––your results are in! Easier than a doctor's checkup, right?"
          subHeader="And FYI we sent a copy to your email."
        />
        <form ref={formRef}>
          <div className="pt-6 flex flex-col">
            <div className="pb-4">
              <Button
                element="a"
                href={`${getApiHostname()}/insurance/coverage-checkup/${guid}/success`}
                fullWidthOnMobile={true}
                target="_blank"
                rel="noopener"
              >
                <Icon icon={LinkExternalIcon} className="mr-2" />
                View My Results
              </Button>
            </div>
            <div>
              <Button
                element="a"
                href={`${getApiHostname()}/insurance/coverage-checkup/${guid}/success.pdf`}
                fullWidthOnMobile={true}
                target="_blank"
                rel="noopener"
                appearance="ghost"
              >
                <Icon icon={DownloadOutlinedIcon} className="mr-2" />
                Download My Results
              </Button>
            </div>
            <div className="pt-6 pb-6">
              <Button
                fullWidthOnMobile={true}
                appearance="subtle"
                element="a"
                onClick={() => dispatch(resetState())}
              >
                <Icon icon={RefreshIcon} className="mr-2" />
                Retake
              </Button>
            </div>
          </div>
        </form>
        <hr className="mt-3 text-gray-30 hidden md:block" />
        <div className="font-semibold pt-1 pb-4">
          If you found this tool helpful—share it!
        </div>
        <div className="flex justify-center">
          <Input
            name="copyCoverageCheckupLink"
            length="md"
            id="copyCoverageCheckupLink"
            data-testid="copy_coverage_checkup_link"
            value={`${getApiHostname()}/insurance/coverage-checkup`}
            className="pr-1"
            readOnly
          />
          <Button onClick={copyToClipboard}>
            <Icon icon={LinkIcon} className="mr-1" />
            {copyButtonMessage}
          </Button>
        </div>
      </div>
    </CardPadding>
  );
}
